import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

// Third Party
import BlogBink, { BlogBinkPosts } from '@ubo/blog-bink'

// Components
import PostGrid from 'components/elements/Posts/PostGrid'
import Title from 'components/elements/Title'

// Hooks
import usePost from 'hooks/usePost'

interface OtherStoriesProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_PostTypes
  location: any
}

const OtherStories: React.FC<OtherStoriesProps> = ({ fields }) => {
  const {
    allWpPost,
    // eslint-disable-next-line
  } = useStaticQuery<GatsbyTypes.OtherStoriesQueryQuery>(graphql`
    query OtherStoriesQuery {
      allWpPost(
        filter: {
          categories: {
            nodes: { elemMatch: { slug: { eq: "klantverhalen" } } }
          }
        }
        sort: { order: DESC, fields: date }
      ) {
        edges {
          node {
            ...generalPostFragment
          }
        }
      }
    }
  `)

  const posts: unknown = allWpPost.edges

  const post: any = usePost()

  return (
    <section>
      <div className="pt-5 container">
        <Title>ook interessant</Title>
      </div>
      <BlogBink
        posts={posts as BlogBinkPosts}
        hideIds={post ? [post.databaseId] : []}
        id="other_stories"
        limit={3}
      >
        <div className="pb-5">
          <PostGrid fields={fields} />
        </div>
      </BlogBink>
    </section>
  )
}

export default OtherStories
